import { render } from "./GalleryItemMobile.vue?vue&type=template&id=5789bd96&scoped=true"
import script from "./GalleryItemMobile.vue?vue&type=script&lang=js"
export * from "./GalleryItemMobile.vue?vue&type=script&lang=js"

import "./GalleryItemMobile.vue?vue&type=style&index=0&id=5789bd96&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5789bd96"]])

export default __exports__